import React from 'react';
import PropTypes from 'prop-types';
import b_ from 'b_';
import cn from 'classnames';
import FuseInfoTooltip from '../FuseControls/FuseTooltip/FuseInfoTooltip';
import './ConsoleFragments.css';

const block = b_.lock('ConsoleField');

export default function ConsoleField(props) {
    const {
        name,
        children,
        className,
        info,
        infoPosition,
        titleClassName,
        disabled,
        ...otherProps
    } = props;
    return <div
        className={cn(block({ disabled }), className)}
        {...otherProps}
    >
        <div className={cn(block('Title'), titleClassName)}>
            <span>{name}</span>
            {info ? <FuseInfoTooltip
                iconClassName={block('Info')}
                position={infoPosition}
                inline
            >{info}</FuseInfoTooltip> : null}
        </div>
        <div className={block('Content')}>
            {children}
        </div>
    </div>;
}

ConsoleField.propTypes = {
    name: PropTypes.string.isRequired,
    info: PropTypes.node,
    infoPosition: PropTypes.string,
    disabled: PropTypes.bool,
    titleClassName: PropTypes.string,
};
